/** 隐私政策抽屉（→ 登录弹窗《隐私政策》入口，叠在登录/找回密码弹窗之上） */
export const usePrivacyNav = () => {
  const open = useState('privacy-drawer-open', () => false)

  const openPrivacy = () => {
    open.value = true
  }

  const closePrivacy = () => {
    open.value = false
  }

  return { open, openPrivacy, closePrivacy }
}
